<template>
  <div>
    <navbar />
    <div
      class="couponDetailsBox"
      :style="{background: '#FFF6EF url('+cssBoxStyle.url+') no-repeat',backgroundSize:'cover'}"
    >
      <div class="core-container">
        <div
          class="widget-breadcrumb"
          @click="goHomePage"
        ><span> {{ $t("detailContent.returnHome") }}</span></div>
        <div class="couponDetailsContent row">
          <div class="leftDetailsBox col-12 col-sm-4">
            <div class="publicityImg">
              <img
                :src="couponsList.detailBannerUrl"
                alt=""
              >
            </div>
            <!-- <div class="shareFriend"><span>{{ $t("detailContent.shareFrind") }}</span></div>
            <ul class="shareIconList">
              <li><img src="@/assets/images/facebook.svg" alt=""></li>
              <li class="iconWechat"><img
                src="@/assets/images/whatsapp.svg"
                alt=""></li>
              <li class="iconTwitter"><img
                src="@/assets/images/twitter.svg"
                alt=""></li>
              <li class="iconEmail"><img
                src="@/assets/images/email.svg"
                alt=""></li>
            </ul> -->
          </div>
          <div class="rightDetailsBox col-12 col-sm-8">
            <div class="wrapper">
              <div class="couponDetailedInformation">
                <div class="couponDetailedInformation_top">
                  <div class="topInformation_information">
                    <span class="merchant">{{ couponsList.merchantName }}</span>
                    <span class="topInformation_money">{{ couponsList.shortDescription }}</span>
                    <span class="topInformation_date">Validity Period: {{ couponsList.effectiveStartDate }} - {{ couponsList.effectiveEndDate }}</span>
                  </div>
                  <div class="topInformation_address">

                    <div class="topInformation_addressTitle">
                      <img
                        src=""
                        alt=""
                      >
                      <span>{{ $t("detailContent.branch") }}</span>
                    </div>
                  </div>
                </div>
                <div class="couponDetailedInformation_bottom">
                  <div class="detailsRedeemBtn">
                    <template v-if="Number(couponsList.price) === 0">
                      <div
                        class="small_redeem_button"
                        @click="goReceive(couponsList.couponId)"
                      >
                        <i class="icon">
                          <img src="@/assets/images/icon-heart.svg">
                        </i>
                        Download
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="small_redeem_button price_button"
                        @click.stop="addCart(couponsList)"
                      >
                        <i class="icon iconfont icon-shopping"></i>
                        ${{ parseFloat(couponsList.price).toFixed(2) }}
                      </div>
                    </template>
                  </div>
                  <div class="couponDownloadBox">
                    <div class="couponDownloadLeftBox">
                      <img
                        src="@/assets/images/user.svg"
                        alt=""
                      >
                      <div class="couponDownloadLeftBox_Downloaded">
                        <span class="DownloadedNumber">{{ couponsList.downloadCount }}</span>
                        <span class="DownloadedTitle">{{ Number(couponsList.price) === 0 ? $t('detailContent.downloaded') : $t('detailContent.bought') }}</span>
                      </div>
                    </div>

                    <div class="couponDownloadLeftBox theme1">
                      <div class="couponDownloadLeftBox_Downloaded">
                        <span class="DownloadedNumber">{{ judgeRemainingCount }}</span>
                        <span class="DownloadedTitle">{{ $t('detailContent.remainder') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="couponExchangeBox">
                <div class="couponExchangeBox_title"><span>{{ $t("detailContent.exchangeMethod") }}</span></div>
                <ul class="couponExchangeList row">
                  <li class="couponExchangecontent col-12 col-sm-4">
                    <div class="stepBox">1</div>
                    <div class="couponExchangecontent_img">
                      <div class="img-wrapper"><img
                          src="../../assets/images/s1.svg"
                          class="img-fluid"
                          alt=""
                        ></div>
                      <div class="exchangeTitle1">登記</div>
                    </div>

                  </li>
                  <li class="couponExchangecontent col-12 col-sm-4">
                    <div class="stepBox">2</div>
                    <div class="couponExchangecontent_img">
                      <div class="img-wrapper"><img
                          src="../../assets/images/s2.svg"
                          class="img-fluid"
                          alt=""
                        ></div>
                      <div class="exchangeTitle1">加入電子錢包</div>
                    </div>

                  </li>
                  <li class="couponExchangecontent col-12 col-sm-4">
                    <div class="stepBox">3</div>
                    <div class="couponExchangecontent_img">
                      <div class="img-wrapper"><img
                          src="../../assets/images/s3.svg"
                          class="img-fluid"
                          alt=""
                        ></div>
                      <div class="exchangeTitle1">店鋪內展示QR</div>
                    </div>

                  </li>
                </ul>
              </div>
              <div class="couponTermsBox">
                <span class="couponTermsBox_title">{{ $t("detailContent.clause") }}: </span>
                <span
                  v-for="item in couponsList.terms"
                  :key="item.id"
                >{{ item }}</span>
                <span>{{ $t("detailContent.clauseContent1") }}</span>
                <span>{{ $t("detailContent.clauseContent2") }}</span>
                <span>{{ $t("detailContent.clauseContent3") }}</span>

              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="couponDetailsBanner">
        <img
          :src="couponsList.couponBannerUrl"
          alt=""
        >
      </div>
    </div>
    <footerBox />

    <div
      class="receiveCouponBox"
      :style="{background: 'rgba(15, 150, 187, 0.9)'}"
      v-show="receivePage"
    >
      <div
        class="receiveCouponBox_close"
        @click="closeReceiveBox"
      >
        <img
          src="@/assets/images/close.svg"
          alt=""
        >
        <span>close</span>
      </div>
      <div
        class="receiveCouponContent"
        v-show="inputEmailPage"
      >
        <span class="receiveCouponContent_title">登記優惠券</span>
        <span class="receiveCouponContent_title2">立即登記以尊享獨家禮遇</span>
        <input
          type="text"
          placeholder="郵箱"
          v-model="inputEmail"
        >
        <span
          v-if="errorMessage"
          style="color: red; font-family: Roboto, Microsoft YaHei, STHeiTi, sans-serif, simsun;"
        >
          {{ $t(errorMessage) }}
        </span>
        <div
          class="receiveCouponContent_register"
          @click="receiveEmail"
        > > 立即登記</div>
      </div>
      <div
        class="completeCouponContent"
        v-if="completePage"
      >
        <div class="completeCouponContent_top">
          <img
            src="@/assets/images/email.svg"
            alt=""
          >
          <div class="completeInformation">
            <span class="completeInformationTitle1">成功登記</span>
            <span class="completeInformationTitle2">優惠券已經發送至登記電郵!</span>
          </div>
        </div>
        <div class="complete_couponEventContent">
          <div class="complete_couponEventContent_img">
            <img
              :src="couponsList.detailBannerUrl"
              alt=""
            >
          </div>
          <div class="complete_content_right">
            <div class="complete_content_right_img">
              <span>{{ couponsList.merchantName }}</span>
            </div>
            <ul>
              <li
                v-if="couponsList.couponType==='Percentage Off'"
                class="complete_per_symbol"
              ><span class="complete_percentage">{{ parseFloat(parseFloat(couponsList.amount).toFixed(2)) }}</span>{{ couponsList.symbol }}</li>
              <li
                v-if="couponsList.couponType==='Fixed Amount'"
                class="complete_per_symbol"
              >{{ couponsList.symbol }}<span class="complete_percentage">{{ parseFloat(parseFloat(couponsList.amount).toFixed(2)) }}</span></li>
              <li
                v-if="couponsList.couponType==='Amount Off'"
                class="complete_per_symbol"
              >{{ couponsList.symbol }}<span class="complete_percentage">{{ parseFloat(parseFloat(couponsList.amount).toFixed(2)) }}</span>off</li>
              <li class="complete_per_text">Purchasing offer</li>
              <li class="complete_validityDate">Validity Period: {{ couponsList.effectiveStartDate }} ~ {{ couponsList.effectiveEndDate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from '@/components/navbar.vue'
import footerBox from '@/components/footer.vue'
import { getCouponDetail, receiveCoupon } from '@/api/coupon'
import { mapMutations } from 'vuex'

export default {
  components: {
    navbar,
    footerBox
  },
  data () {
    return {
      fullWidth: document.documentElement.clientWidth,
      cssBoxStyle: {
        url: require('@/assets/images/ribbon.svg')
      },
      cssrabbitBg: require('@/assets/images/rabbitBg.svg'),
      couponsList: [],
      couponId: '',
      inputEmail: '',
      detailPage: true,
      receivePage: false,
      inputEmailPage: true,
      completePage: false,
      completeCouponbox: '',
      errorMessage: ''
    }
  },
  mounted () {
    this.couponId = this.$route.params.couponId

    getCouponDetail(this.couponId).then(res => {
      this.couponsList = res.data
      console.log(this.couponsList)
    })

    const that = this
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth
        that.fullWidth = window.fullWidth
        console.log(that.fullWidth)
      })()
    }
  },
  methods: {
    ...mapMutations('cart', [
      'addCart'
    ]),
    goReceive: function (params) {
      this.inputEmailPage = true
      this.receivePage = true
      this.completePage = false
      if (localStorage.getItem('userReceiveEmail') != '') {
        this.inputEmail = localStorage.getItem('userReceiveEmail')
      }
    },
    receiveEmail: function (params) {
      if (!this.inputEmail) {
        alert('请输入邮箱')
      } else {
        const downloadparams = {
          couponId: this.couponId,
          email: this.inputEmail.toString()
        }
        console.log(downloadparams)

        receiveCoupon({
          couponId: this.couponId,
          email: this.inputEmail.toString()
        }).then(res => {
          this.inputEmailPage = false
          this.completePage = true
          localStorage.setItem('userReceiveEmail', this.inputEmail.toString())
        }).catch((error) => {
          if (error.response.data.meta) {
            const errorType = error.response.data.meta.error
            if (errorType === 'NO_ENOUGH_COUPON') {
              this.errorMessage = 'error.coupon-overflow'
            } else if (errorType === 'REACH_MAX_DOWNLOAD_LIMIT') {
              this.errorMessage = 'error.coupon-download-limit'
            } else {
              this.errorMessage = 'error.coupon-error'
            }
          } else {
            this.errorMessage = 'error.coupon-error'
          }
        })
      }
    },
    closeReceiveBox: function (params) {
      this.receivePage = false
    },
    goHomePage: function (params) {
      this.$router.push({ path: '/' })
    }
  },
  computed: {
    judgeRemainingCount: function () {
      return ((this.couponsList.remainingCount < 0) || (this.couponsList.remainingCount > 100)) ? '100+' : this.couponsList.remainingCount
    }
  }
}
</script>

<style lang="scss">
.publicityImg {
  width: 100%;
}
.publicityImg img {
  width: 100%;
  border-radius: 5px;
}

.stepBox {
  background: #ffbf00;
  position: absolute;
  left: 10px;
  top: 0px;
  color: white;
  display: inline-block;
  height: 30px;
  width: 30px;
  line-height: 1.4;
  border-radius: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
}

.exchangeImg2 {
  width: 117% !important;
}
.exchangeImg3 {
  width: 110% !important;
}

.couponTermsBox {
  padding: 14px;
  padding-bottom: 60px;
}
.couponTermsBox span {
  display: block;
  text-align: left;
  font-style: normal;
  font-size: 14px;
  line-height: 30px;
  color: #666666;
}
.couponDetailsBanner {
  max-height: 500px;
  overflow: hidden;
  margin-top: 80px;
}
.couponDetailsBanner img {
  width: 100%;
}
.receiveCouponBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-size: 35% !important;
  transition-duration: 0.5s;
}
.receiveCouponContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 500px;
  height: 500px;
  top: 350px;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 50%;
  background-color: #fff;
  z-index: 1000;
  transition-duration: 0.5s;
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 30%;
    height: 400px;
    top: -300px;
    border-radius: 50%;
    background-color: #fff;
    z-index: 100;
  }
  &::before {
    left: 0%;
    transform: rotate(-30deg);
  }
  &::after {
    right: 0%;
    transform: rotate(30deg);
  }
  @media screen and(max-width:768px) {
    width: 75vw;
    height: 75vw;
    top: 55vw;
    &::before,
    &::after {
      width: 30%;
      height: 55vw;
      top: -42vw;
    }
  }
}
.receiveCouponContent_title {
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  color: #0f96bb;
}
.receiveCouponContent_title2 {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
}
.receiveCouponContent input {
  border: 0;
  height: 50px;
  font-size: 18px;
  border-bottom: 1px solid #dfdfdf;
}
.receiveCouponContent input:focus {
  outline: medium;
  border: 0;
  border-bottom: 3px solid #dfdfdf;
}
.receiveCouponContent_register {
  width: 60%;
  padding: 10px 0;
  font-size: 20px;
  text-align: center;
  color: #ffffff;
  background: #ffbf00;
  border-radius: 3px;
  margin: 10px auto 0;
  cursor: pointer;
}
.completeCouponContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition-duration: 0.5s;
  position: absolute;
  width: 500px;
  height: 500px;
  top: 350px;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 50%;
  background-color: #fff;
  z-index: 1000;
  transition-duration: 0.5s;
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 30%;
    height: 400px;
    top: -300px;
    border-radius: 50%;
    background-color: #fff;
    z-index: 100;
  }
  &::before {
    left: 0%;
    transform: rotate(-30deg);
  }
  &::after {
    right: 0%;
    transform: rotate(30deg);
  }
  @media screen and(max-width:768px) {
    width: 75vw;
    height: 75vw;
    top: 55vw;
    &::before,
    &::after {
      width: 30%;
      height: 55vw;
      top: -42vw;
    }
  }
}
.completeCouponContent_top {
  width: 75%;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  border-bottom: 1px dashed #e4e4e4;
}
.completeInformationTitle1 {
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  color: #0f96bb;
  text-align: left;
}
.completeInformation {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.completeInformationTitle2 {
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  color: #000000;
}

.complete_couponEventContent {
  width: 75%;
  position: relative;
  overflow: hidden;
  padding: 0;
  float: left;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.complete_couponEventContent_img {
  overflow: hidden;
  width: 125px;
  height: 125px;
  border-radius: 50%;
}
.complete_couponEventContent_img img {
  position: relative;
  height: 100%;
}
.complete_content_right {
  width: 54%;
}
.complete_content_right_img {
  text-align: right;
  transform: translateY(15px);
}
.complete_content_right_img img {
  width: 30%;
}
.complete_couponEventContent ul {
  list-style-type: none;
  padding-left: 0px;
  text-align: left;
  margin-left: 10px;
  margin-bottom: 12px;
}
.complete_percentage {
  font-style: normal;
  font-weight: 800;
  font-size: 55px;
  line-height: 67px;
  color: #0f96bb;
}

ul .complete_per_symbol {
  color: #0f96bb;
  font-weight: normal;
  font-size: 22px;
}
ul .complete_per_text {
  font-weight: normal;
  font-size: 14px;
  color: #000000;
}

ul .complete_validityDate {
  font-weight: normal;
  font-size: 13px;
  color: #b3b3b3;
}

@media (max-width: 1600px) and (min-width: 1400px) {
  .receiveCouponBox {
    background-size: 40% !important;
  }
}
@media (max-width: 1400px) and (min-width: 1000px) {
  .receiveCouponBox {
    background-size: 46% !important;
  }
}
@media (max-width: 1300px) and (min-width: 1000px) {
  .receiveCouponBox {
    background-size: 45% !important;
  }
}
@media (max-width: 1150px) and (min-width: 1000px) {
  .receiveCouponBox {
    background-size: 50% !important;
  }
}

@media screen and (max-width: 768px) {
  .completeInformationTitle1 {
    font-size: 20px;
  }
  .completeInformationTitle2 {
    font-size: 16px;
    text-align: left;
  }
  .complete_couponEventContent_img {
    width: 75px;
    height: 75px;
  }
  .complete_per_symbol {
    margin-top: 10px;
    .complete_percentage {
      font-size: 30px;
      line-height: 30px;
    }
  }
}

@media screen and (max-width: 350px) {
  .completeCouponContent {
    width: 85vw;
    height: 300px;
  }
}
</style>
